import { Button, Grid, IconButton, MenuItem, Select, TextField, Tooltip} from "@material-ui/core";
import { NearMe } from "@material-ui/icons";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { handleCurrentRouteType } from "../../../../actions/rmActions";
import { MapModes } from "../../../../constants/general";
import { getUserPreference } from "../../../../utilities/common";
import { useToken } from "../../../../utilities/hooks";

function RegularRouting(props){
    const {
        onSave, 
        handleQuickRouting, 
        handleRoutePreview,
        ...style
    } = props
    const {t} = useTranslation('mapManagement');
    const dispatch = useDispatch();
    const userPref = getUserPreference();
    const tokenContents = useToken();

    const userUS = tokenContents.userUS;

    const routeType = useSelector(state=>state.mapManagement.routeType)

    return (
        <Grid container spacing={1} {...style}>
            {/* <Grid container item xs={10} spacing={1}>
                <Grid item xs={8} key="route-start-grid">
                    <TextField
                        id="route-start-text"
                        variant="outlined"
                        size='small'
                        label="Start"
                        defaultValue={routePlanner.start !== null ? `${routePlanner.start.lat}, ${routePlanner.start.lng}`:null}
                        fullWidth
                    />
                </Grid>
                <Grid item xs={4}>
                    <Tooltip title="Set Route Start">
                        <IconButton 
                            size='small' 
                            color={currentMapMode === MapModes.SELECT_START ? 'secondary': 'default'}
                            onClick={()=>handleMapModeChange(MapModes.SELECT_START)}
                        >
                            <NearMe />
                        </IconButton>
                    </Tooltip>
                </Grid>
                <Grid item xs={8} key="route-end-grid">
                    <TextField
                        id="route-end-text"
                        variant="outlined"
                        size='small'
                        label="End"
                        defaultValue={routePlanner.end !== null ? `${routePlanner.end.lat}, ${routePlanner.end.lng}`: null}
                        fullWidth
                    />
                </Grid>
                <Grid item xs={4}>
                    <Tooltip title="Set Route End">
                        <IconButton 
                            size='small'
                            color={currentMapMode === MapModes.SELECT_END ? 'secondary': 'default'}
                            onClick={()=>handleMapModeChange(MapModes.SELECT_END)}
                        >
                            <NearMe />
                        </IconButton>
                    </Tooltip>
                </Grid>
            </Grid> */}
            <Grid item xs={6} style={{marginBottom:20}}>
                <TextField
                    select
                    value={routeType}
                    variant="outlined"
                    onChange={(event) => { dispatch(handleCurrentRouteType(event.target.value)) }}
                    fullWidth
                >
                    <MenuItem value={1} >{t('original_planning_method')}</MenuItem>
                    {/* Only for CA for now */}
                    {
                        (!userUS) &&
                        <MenuItem value={2}>{t('vrp_planning_method')}</MenuItem>
                    }
                    <MenuItem value={3}><div>{t('hopper_planning_method')}</div></MenuItem>
                </TextField>
            </Grid>
            <Grid item xs={3} style={{marginBottom:20}}>
                <Button 
                    variant="outlined"
                    fullWidth
                    onClick={handleRoutePreview}
                    size="large"
                >
                    Preview
                </Button>
            </Grid>
            {/* <Grid item xs={3}> */}
                {/* <Button 
                    variant="outlined"
                    fullWidth
                    onClick={handleQuickRouting}
                >
                    Quick
                </Button> */}
            {/* </Grid> */}
            {/* <Grid item xs={3}> */}
                {/* <Button 
                    variant="outlined"
                    fullWidth
                    onClick={handleRoutePreview}
                    disabled
                >
                    Clear Notes
                </Button> */}
            {/* </Grid> */}
            {/* <Grid item xs={3}> */}
                {/* <Button 
                    variant="outlined"
                    fullWidth
                    onClick={handleRoutePreview}
                    disabled
                >
                    Clear Route
                </Button> */}
            {/* </Grid> */}
            <Grid item xs={3}>
                <Button
                    variant="contained"
                    color='secondary'
                    fullWidth
                    onClick={onSave}
                    // style={{height: '100%'}}
                    size="large"
                >
                    Save
                </Button>
            </Grid>
            {
                routeType === 3 &&
                <Grid item xs={12} style={{marginBottom: 20}}>
                    {t('hopper_planning_method_not_change')}
                </Grid>
            }
        </Grid>
    )
}

export default RegularRouting